import React from 'react'
import IcomoonReact from 'icomoon-react'
import { isEmpty } from 'lodash'
import { useGlobalContext } from 'src/stores/GlobalContext'
import Button from 'src/components/Elements/Button'
import rebrandIconSet from 'src/assets/icons/rebrandIconList.json'
import variables from 'src/assets/styles/variables.module.scss'

const FeedbackButton = ({ session, detailView }) => {
  const { setSidePanelDetails } = useGlobalContext()

  const openEval = () => {
    session.session_type_key === 'session_type_one_to_one_meeting'
      ? setSidePanelDetails({ type: 'p2p_evaluation', data: session.id })
      : setSidePanelDetails({ type: 'evaluation', data: session.id })
  }

  if (isEmpty(session) || session.registration_status === 'not_authorized') return <></>

  return (
    <Button
      color={session.evaluation_completed ? 'lightActive' : 'lightBase'}
      onClick={() => openEval()}
      label={
        session?.evaluation_completed ? 'Feedback Given' : 'Give Feedback'
      }
      size={detailView ? 'med' : 'small'}
      disabled={session.evaluation_completed}
      iconRight={
        session?.evaluation_completed
          ? (
            <IcomoonReact
              icon="Tick"
              iconSet={rebrandIconSet}
              color={variables.white}
              size={detailView ? 16 : 12}
            />
          )
          : null
      }
    />
  )
}

export default FeedbackButton
